<template>
  <div class='userIcon'>
    <svg :width="tam" :height="tam" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="9" r="3" :stroke="color" stroke-width="1.5"/>
      <circle cx="12" cy="12" r="10" :stroke="color" stroke-width="1.5"/>
      <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'userIcon',
  props: {
    color: {
      type: String,
      default: '#CCCCCC'
    },
    tam: {
      type: String,
      default: '19px'
    }
  }
}
</script>

<style scoped>
.userIcon {
  cursor: pointer;
}
</style>
